import { useVisualGuides } from "../../i18n/useVisualGuides";
import { GuideStepList } from "./GuideStep";
import {
  SketchBoardAndResult,
  SketchExportMenu,
  SketchMaterialCard,
  SketchProjectInput,
} from "./GuideSketches";

const VISUALS = [
  <SketchMaterialCard key="material" />,
  <SketchProjectInput key="projects" />,
  <SketchBoardAndResult key="layout" />,
  <SketchExportMenu key="export" activeItem="pdf" />,
];

export function HowGuideVisual() {
  const visualGuides = useVisualGuides();
  const guide = visualGuides.how;

  return <GuideStepList intro={guide.intro} steps={guide.steps} visuals={VISUALS} />;
}
